module.exports = __webpack_public_path__ + "img/fedbckclose.6b45cbc1.svg";